import styled, { css } from 'styled-components';
import { EButtonSize, EButtonType, TButton } from './button.types';

const mixinButton = (
    text: string,
    bgMain: string,
    textHover?: string,
    bgHover?: string,
    textVisited?: string,
    bgVisited?: string,
) => css`
    color: ${text};
    background-color: ${bgMain};
    &:hover {
        color: ${textHover ?? text};
        background-color: ${bgHover ?? bgMain};
    }
    &:active,
    &:focus,
    &:visited {
        color: ${textVisited ?? textHover ?? text};
        background-color: ${bgVisited ?? bgHover ?? bgMain};
    }
`;

export const ButtonStyles = styled.button<TButton>`
    ${({ theme }) => theme.mixins.flexCenter};
    border: none;
    padding: 0.5rem 1rem;
    border-radius: ${({ theme }) => theme.defaults.borderRadius};

    ${({ inline }) =>
        inline &&
        css`
            display: inline;
        `};
    &:focus,
    &:active,
    &:visited {
    }

    cursor: pointer;
    transition: all 300ms;

    ${({ size, theme }) => {
        switch (size) {
            case EButtonSize.Big:
                return css`
                    width: 100%;
                    min-height: 50px;
                    min-width: 200px;
                    padding: 14px 50px;
                    ${theme.typography.buttonText_1};
                `;
            case EButtonSize.Small:
                return css`
                    width: max-content;
                    min-width: 80px;
                    min-height: 36px;
                    //padding: 8px 20px;
                    padding: 0 16px;
                    ${theme.typography.buttonText_2};
                `;
            default:
            case EButtonSize.Normal:
                return css`
                    width: max-content;
                    min-height: 40px;
                    min-width: 120px;
                    padding: 8px 28px;
                    ${theme.typography.buttonText_1};
                `;
        }
    }};

    ${({ styleType, theme, disabled, color }) => {
        switch (styleType) {
            case EButtonType.Danger:
                return css`
                    ${mixinButton(
                        theme.branding.white.lighter,
                        theme.branding.tertiary.main,
                        theme.branding.white.lighter,
                        theme.branding.tertiary.dark,
                    )};
                    ${disabled &&
                    css`
                        ${mixinButton(
                            theme.branding.white.lighter,
                            theme.branding.tertiary.light,
                        )}
                    `}
                `;
            case EButtonType.Outline:
                return css`
                    border: 1px solid ${theme.branding.primary.main};
                    ${mixinButton(
                        theme.branding.primary.main,
                        theme.branding.white.lighter,
                        theme.branding.primary.darker,
                        theme.branding.primary.light,
                    )};
                    ${(() => {
                        switch (color) {
                            case 'secondary':
                                return css`
                                    border-color: ${theme.branding.secondary
                                        .main};
                                    color: ${theme.branding.secondary.main};
                                `;
                            case 'primary':
                            default:
                                return;
                        }
                    })()}
                    ${disabled &&
                    css`
                        border: 1px solid ${theme.branding.gray.main};
                        ${mixinButton(
                            theme.branding.gray.main,
                            theme.branding.white.lighter,
                        )}
                    `}
                `;
            case EButtonType.Secondary:
                return css`
                    ${mixinButton(
                        theme.branding.text.light,
                        theme.branding.secondary.main,
                        undefined,
                        theme.branding.secondary.dark,
                        undefined,
                        theme.branding.secondary.darker,
                    )};
                    ${disabled &&
                    mixinButton(
                        theme.branding.gray.dark,
                        theme.branding.gray.light,
                    )};
                `;
            case EButtonType.Contrast:
                return css`
                    ${mixinButton(
                        theme.branding.text.dark,
                        theme.branding.white.lighter,
                        theme.branding.gray.darker,
                        theme.branding.gray.main,
                    )};
                    ${disabled &&
                    mixinButton(
                        theme.branding.gray.main,
                        theme.branding.gray.lighter,
                    )};
                `;
            default:
            case EButtonType.Primary:
                return css`
                    ${mixinButton(
                        theme.branding.text.light,
                        theme.branding.primary.main,
                        undefined,
                        theme.branding.primary.dark,
                        undefined,
                        theme.branding.primary.darker,
                    )};
                    ${disabled &&
                    mixinButton(
                        theme.branding.gray.dark,
                        theme.branding.gray.light,
                    )};
                `;
        }
    }};

    ${({ wide }) =>
        wide &&
        css`
            width: 100%;
        `}

    ${({ noPadding }) =>
        noPadding &&
        css`
            padding: 0;
        `}
`;
